import { css } from '@emotion/core';
import ds from './utils/ds';

// TODO: Add support for dynamic fonts
import openSansLight from './assets/fonts/OpenSans-Light.ttf';
import openSansLightItalic from './assets/fonts/OpenSans-LightItalic.ttf';
import openSansRegular from './assets/fonts/OpenSans-Regular.ttf';
import openSansRegularItalic from './assets/fonts/OpenSans-Italic.ttf';
import openSansBold from './assets/fonts/OpenSans-Bold.ttf';
import openSansBoldItalic from './assets/fonts/OpenSans-BoldItalic.ttf';
import leagueSpartanMedium from './assets/fonts/LeagueSpartan-Medium.ttf';

export default css`
  @font-face {
    font-family: 'Open Sans';
    font-weight: 300;
    src: url(${openSansLight}) format('truetype');
  }
  @font-face {
    font-family: 'Open Sans';
    font-weight: 300;
    font-style: italic;
    src: url(${openSansLightItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Open Sans';
    font-weight: 400;
    src: url(${openSansRegular}) format('truetype');
  }
  @font-face {
    font-family: 'Open Sans';
    font-weight: 400;
    font-style: italic;
    src: url(${openSansRegularItalic}) format('truetype');
  }
  @font-face {
    font-family: 'Open Sans';
    font-weight: 700;
    src: url(${openSansBold}) format('truetype');
  }
  @font-face {
    font-family: 'Open Sans';
    font-weight: 700;
    font-style: italic;
    src: url(${openSansBoldItalic}) format('truetype');
  }
  @font-face {
    font-family: 'League Spartan Medium';
    src: url(${leagueSpartanMedium}) format('truetype');
  }

  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)*/
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  html {
    font-family: ${ds.getFont()};
  }
  html,
  body {
    height: 100%;
  }
  body {
    font-smoothing: antialiased;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  strong {
    font-weight: bold;
  }
  #tabs__header {
    top: 60px;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }
`;
